<script setup>
import { nav_1, nav_2 } from '@/mock/sandbox.js'
function toApply() {
  window.open('https://cdn.isc.360.com/iscvideo-bucket/ISC_2023_call_sandbox.zip', '_self ')
}
</script>

<template>
  <div class="sandbox">
    <img src="https://p0.ssl.qhimg.com/t01eff98d5b57c0aaf3.jpg" alt="" class="sandboxBgc" />
    <div class="sandboxNav">
      <img :src="nav_1.src" :alt="nav_1.alt" />
      <img
        src="https://p5.ssl.qhimg.com/t0138973a8b1c1b5b75.png"
        alt="按钮"
        class="sandboxBtn"
        @click="toApply"
      />
      <p class="sandboxText">
        下载大赛报名表格，<span style="color: #0031f9">发送至ISC@360.cn</span>
      </p>
      <img :src="nav_2.src" :alt="nav_2.alt" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sandbox {
  position: relative;
  height: 100vh;
  &Bgc {
    position: fixed;
    top: 0;
    min-width: 375px;
    width: 100vw;
  }
  &Nav {
    width: 100vw;
    min-width: 375px;
    text-align: center;
    background-color: #fff;
    position: absolute;
    top: 168px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
  }
  &Btn {
    cursor: pointer;
    margin-top: 34px;
    width: 240px !important;
  }
  &Text {
    font-size: 7px;
    color: #1b1b1b;
    line-height: 12px;
    margin-bottom: 60px;
  }
}
</style>
